<template>
  <NuxtLayout name="default" :show-back-button="false">
    <SofaxBreadcrumb
      :title="t('seo.affiliateTerms.title')"
      :items="[{ name: t('seo.affiliate.title'), to: '/affiliate' }, { name: t('seo.affiliateTerms.title') }]"
    />

    <section class="sofax bg-white dark:bg-gray-950">
      <div class="section-space">
        <div class="shell">
          <SofaxLegalDocument :document="legalDocument" :updated="AFFILIATE_TERMS_VERSION" />
        </div>
      </div>
    </section>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { AFFILIATE_TERMS_VERSION } from '~/constants/affiliate'
import { affiliateTerms } from '~/constants/legal/affiliateTerms'
import { affiliateTermsCs } from '~/constants/legal/affiliateTermsCs'
import { affiliateTermsDe } from '~/constants/legal/affiliateTermsDe'

const { t, locale } = useI18n()

// Same shell as /terms: an explicit NuxtLayout so the back button can be switched off.
definePageMeta({
  layout: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/partnersky-program/podminky', de: '/partnerprogramm/bedingungen', pl: '/program-partnerski/regulamin' } })

const legalDocument = computed(() => (locale.value === 'cs' ? affiliateTermsCs() : locale.value === 'de' ? affiliateTermsDe() : affiliateTerms()))

useSeoMeta({
  title: () => t('seo.affiliateTerms.title'),
  description: () => t('seo.affiliateTerms.description'),
  ogTitle: () => t('seo.affiliateTerms.title'),
  ogDescription: () => t('seo.affiliateTerms.description'),
})
</script>
